import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  Input
} from '@angular/core';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {IdynamicFormItem} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import {FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import {IgenomicsState} from '@ispm/core/interfaces/genomics-state.interface';
import {get, isEmpty, mapKeys, set} from 'lodash';
import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'ispm-managing-organization-facility',
  templateUrl: './managing-organization-facility.component.html',
  styleUrls: ['./managing-organization-facility.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('ManagingOrganizationFacility')
export class ManagingOrganizationFacilityComponent implements OnInit, OnDestroy, IWidgetItem, OnChanges {
  private mapConfigParams: any;
  private destroyed$: Subject<any> = new Subject();
  private currentOrganization: any;

  private _selectedFacility: string;
  private relationKeyFrom: string;
  private relationKeyTo: string;

  public formId: string;
  public title: string;
  public formData: {};
  public isFacilityEnabled: boolean = false;
  public currentFacilities = [];

  public disabled: boolean = false;
  @Input() selectedFacility: string;

  public set widgetDisabledStatus(disabled: boolean) {
    this.disabled = disabled;
  }

  constructor(private _changeDetector: ChangeDetectorRef,
              protected store: Store<IgenomicsState>,
              private _http: HttpInterceptorService) {
  }

  ngOnInit(): void {
    this.store.select('users').take(1).subscribe(users => {
      this.currentOrganization = get(users, 'organizationConfiguration');
      this.isFacilityEnabled = get(this.currentOrganization, 'isFacilityEnabled');
      const orgId = get(this.currentOrganization, 'id');
      let storedFacilitesString = sessionStorage.getItem("facilities");
      if (!storedFacilitesString) {
        sessionStorage.setItem("facilities", `{}`);
      }
      if (this.isFacilityEnabled) {
        let storedFacilites = JSON.parse(storedFacilitesString);
        const orgFacilitties = get(storedFacilites, orgId, []);
        if (orgFacilitties.length === 0) {
          this._http.get(`/organization?partOf=${orgId}&subResourceType=facility`)
            .takeUntil(this.destroyed$.asObservable())
            .map(data => {
              return data.json();
            }).subscribe(tempfacilities => {
            set(storedFacilites, orgId, tempfacilities);
            sessionStorage.setItem("facilities", JSON.stringify(storedFacilites));
            this.currentFacilities = tempfacilities;
            this.prepareFormData();
          });
        } else {
          this.currentFacilities = orgFacilitties;
          this.prepareFormData();
        }
      } else {
        if (isEmpty(this.formData)) {
          this.mapConfigData(this.currentOrganization);
        }
      }
    });
  }

  set widgetConfig(widgetConfig: IdynamicFormItem<any>) {
    if (widgetConfig && widgetConfig.widgetPayload) {
      let payload = widgetConfig.widgetPayload;
      this.formId = get(payload, 'formId', '');
      this.title = get(payload, 'title', '');
      this.mapConfigParams = get(payload, 'mapConfig.params');
      this.relationKeyFrom = get(payload, 'mapConfig.relationKeyFrom');
      this.relationKeyTo = get(payload, 'mapConfig.relationKeyTo');
    }
  };

  set widgetData(_widgetData: any) {
    if (_widgetData && JSON.stringify(this.formData) !== JSON.stringify(_widgetData)) {
      this.formData = _widgetData;
      this._changeDetector.markForCheck();
    }
  };

  widgetFormInstance: FormGroup;
  widgetFormInstanceSubmitted: boolean;
  widgetSubmitStatusValueCallback(value: boolean): void {}
  widgetUpdateValueCallback(value): void {}

  /**
   * Emit data to parent widget
   * @param data
   */
  emit(data) {
    if (data) {
      if (this.widgetUpdateValueCallback) {
        this.widgetUpdateValueCallback.apply(this, [data]);
      }
    }
  }

  /**
   * On change or select facility
   * @param _selectedFacility
   */
  public onselect(_selectedFacility: any) {
    if (this._selectedFacility != this.selectedFacility) {
      this._selectedFacility = this.selectedFacility;
      this.mapConfigData(this.currentFacilities.find(item => get(item, 'id') === this._selectedFacility));
    }
  };

  updateValidate(event) {

  }

  /**
   * Prepare form data from organization or facility
   */
  prepareFormData() {
    if (!isEmpty(this.formData)) {
      let selectedFacilityObj = this.currentFacilities.find(item => get(item, this.relationKeyFrom) === get(this.formData, this.relationKeyTo));
      this.selectedFacility = get(selectedFacilityObj, 'id');
      this._changeDetector.markForCheck();
    }
  }

  /**
   * map form data based on configuration using org data
   * @param data
   * @private
   */
  private mapConfigData(data) {
    if (isEmpty(this.mapConfigParams)) {
      this.formData = data;
    } else {
      let tempData = {};
      mapKeys(this.mapConfigParams, (value, key) => {
        set(tempData, key, get(data, value));
      });
      this.formData = tempData;
    }
    this.emit(this.formData);
    this._changeDetector.markForCheck();

  }
  ngOnChanges(changes: SimpleChanges): void {}

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
